(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.lazyload = window.oneadvanced.lazyload || {};
    window.oneadvanced.lazyload.init = function () {
        //console.log("initialising lazyload...");
        // Get images that has the data-src attribute
        const lazyImages = document.querySelectorAll('img[data-src]');
        const lazyBackgroundImages = document.querySelectorAll('[data-background-src]');

        // If browser doesn't support IntersectionObserver, load all images 
        if (!('IntersectionObserver' in window)) {
            lazyImages.forEach((imageElement) => loadImage(imageElement));
            lazyBackgroundImages.forEach((imageElement) => loadBackgroundImage(imageElement));
            return;
        }

        // Create observer
        window.oneadvanced.lazyload.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio <= 0) {
                    return;
                }

                const imageElement = entry.target;
                loadImage(imageElement);
                window.oneadvanced.lazyload.observer.unobserve(imageElement);
            });
        },
            // Configuration for the observer
            { rootMargin: '100px' } // load images if it gets within 100px
        );

        // Create background observer
        window.oneadvanced.lazyload.backgroundObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio <= 0) {
                    return;
                }

                const imageElement = entry.target;
                loadBackgroundImage(imageElement);
                window.oneadvanced.lazyload.backgroundObserver.unobserve(imageElement);
            });
        },
            // Configuration for the observer
            { rootMargin: '100px' } // load images if it gets within 100px
        );

        // Let all lazy images be observered
        lazyImages.forEach((imageElement) => {
            window.oneadvanced.lazyload.observer.observe(imageElement);
        });

        // Let all lazy background images be observered
        lazyBackgroundImages.forEach((imageElement) => {
            window.oneadvanced.lazyload.backgroundObserver.observe(imageElement);
        });

        function loadImage(imageElement) {
            // If image is within a picture element, set srcset attribute for all source elements
            const parent = imageElement.parentNode;
            if (parent.tagName === 'PICTURE') {
                const sourceElements = parent.querySelectorAll('source');
                sourceElements.forEach((sourceElement) => {
                    sourceElement.srcset = sourceElement.dataset.srcset;
                });
            }

            // Set img src attribute
            imageElement.src = imageElement.dataset.src;
            imageElement.removeAttribute('data-src');
            imageElement.classList.add("lazyloaded");
        }

        function loadBackgroundImage(imageElement) {
            //imageElement.classList.remove("lazy");
            var tempImg = new Image();
            tempImg.onload = function () {
                //console.log("onload executing for: ", imageElement.dataset.backgroundSrc);
                imageElement.style.backgroundImage = 'url(' + tempImg.src + ')';
                imageElement.removeAttribute('data-background-src');
                imageElement.classList.add("lazyloaded");

                // image swap is now successful, lets clean up
                tempImg = null;
            }
            tempImg.onerror = function (error) {
                //console.log(error);
            };
            //console.log("tempImage assigned src of: ", imageElement.dataset.backgroundSrc);
            tempImg.src = imageElement.dataset.backgroundSrc;            
        }
    };
    window.oneadvanced.lazyload.hasLoaded = true;

})();